import { Injectable } from '@angular/core';

export const JWT_TOKEN_LS_KEY = 'JWT_TOKEN';
export const JWT_REFRESH_TOKEN_LS_KEY = 'JWT_REFRESH_TOKEN';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(key: string, value: any) {
    value = JSON.stringify(value);
    window.localStorage.setItem(key, value);
    return true;
  }

  getItem(key: string) {
    const value = window.localStorage.getItem(key) as string;
    try {
      const parsedValue = JSON.parse(value);
      return parsedValue;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  removeItem(key: string) {
    window.localStorage.removeItem(key);
  }

  clearAuth = () => {
    this.removeItem(JWT_TOKEN_LS_KEY);
    this.removeItem(JWT_REFRESH_TOKEN_LS_KEY);
  };
}
